import React from 'react';

const Skill = ({ skill }) => {
    return (
        <div className='bg-gray-200 rounded p-4 shadow-lg cursor-pointer transition transform lg:hover:scale-105'>
            <div className='h-28 py-4'>
                <img className='w-full h-full object-contain' src={skill.image} alt={skill.title} />
            </div>
            <div className='text-justify'>
                <h2 className='text-lg font-bold text-center py-3'>{skill.title}</h2>
                <p className='text-sm '>{skill.body}</p>
            </div>
        </div>
    )
}

export default Skill;
